export enum ContractsTypes {
  GET_CONTRACTS_REQUEST = '@contracts/GET_CONTRACTS_REQUEST',
  GET_CONTRACTS_SUCCESS = '@contracts/GET_CONTRACTS_SUCCESS',
  GET_CONTRACTS_FAILURE = '@contracts/GET_CONTRACTS_FAILURE',
  SEARCH_CONTRACTS_REQUEST = '@contracts/SEARCH_CONTRACTS_REQUEST',
  SEARCH_CONTRACTS_SUCCESS = '@contracts/SEARCH_CONTRACTS_SUCCESS',
  SEARCH_CONTRACTS_FAILURE = '@contracts/SEARCH_CONTRACTS_FAILURE',
  UPDATE_CURRENT_PAGE = '@contracts/UPDATE_CURRENT_PAGE',
}

export interface OrgaoTypes {
  cep: string;
  cidade: string;
  cidade_id: number;
  codigo: string;
  edital_site: string;
  endereco: string;
  estado: string;
  estado_id: number;
  homepage1: string;
  homepage2: string;
  id: number;
  nome: string;
  tipo_orgao: string;
  tipo_orgao_id: number;
  uasg: string;
}

export interface ContractFileTypes {
  bidding_contracts_id: number;
  document_title: string;
  document_type_name: string;
  id: number;
  publication_date_pncp: string;
  url: string;
}

export interface ContractDataTypes {
  contratacao_pncp_id: string;
  contrato_pncp_id: string;
  cpf_cnpj: string;
  data_assinatura: string;
  data_publicacao: string;
  fonte: string;
  id: number;
  id_contrato: number;
  info_complementar: string;
  link_arquivos: string;
  nome_fornecedor: string;
  numero_empenho: string;
  receita: string | null;
  tipo_contrato_id: number;
  tipo_poder: string;
  valor_contratado: number;
  vigencia_fim: string;
  vigencia_inicio: string;
}

export interface CapagTypes {
  id: number;
  capag: string;
  city_id: number;
  state_id: number;
  debt_rating: string;
  debt_ratio: string;
  current_savings_rating: string;
  current_savings_ratio: string;
  relative_liquidity_rating: string;
  relative_liquidity_ratio: string;
}

export interface PublicBodyTypes {
  id: number;
  nome: string;
  tipo_orgao_id?: number;
  tem_capag?: boolean;
  capag?: CapagTypes;
}

export interface ContractItemTypes {
  _source: {
    atividade: string;
    contratos: Array<ContractDataTypes>;
    contratos_arquivos: Array<ContractFileTypes> | null;
    created: string;
    data_validade: string;
    datahora_abertura: string | null;
    datahora_documento: string | null;
    datahora_prazo: string | null;
    datahora_retirada: string | null;
    datahora_visita: string | null;
    edital: string;
    edital_preco: number;
    edital_tem: boolean;
    id: number;
    itens: string;
    modalidade_id: number;
    modalidade_nome: string;
    modalidade_sigla: string;
    modified: string;
    objeto: string;
    observacao: string;
    orgao: OrgaoTypes;
    orgao_id: string;
    processo: string;
    tipo_agrupamento_descricao: string;
    tipo_agrupamento_id: number;
    tipo_agrupamento_resumo: string;
    valor_estimado: number;
    public_body: Array<PublicBodyTypes> | null;
  };
}

export interface ContractTypes {
  contract: Array<ContractItemTypes>;
  currentPage: number;
  postsPerPage: number;
  total_entries: number;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface ContractsState {
  contracts: ContractTypes;
  readonly request: RequestState;
}
